import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from "i18next-http-backend";

import enTranslation from './locales/en.json';
import nlTranslation from './locales/nl.json';
import deTranslation from './locales/de.json';

const resources = {
  en: {
    translation: enTranslation.translation
  },
  nl: {
    translation: nlTranslation.translation
  },
  de: {
    translation: deTranslation.translation
  }
};

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: { order: ["path", "navigator"] },
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
